import {
  boolean,
  index,
  integer,
  jsonb,
  pgTable,
  text,
  timestamp,
  varchar,
} from 'drizzle-orm/pg-core';
import { id, timestamps } from './_shared';

export const aiCallLog = pgTable(
  'ai_call_log',
  {
    id: id(),
    userId: text('user_id'),
    caller: varchar('caller', { length: 64 }).notNull(),
    modelId: varchar('model_id', { length: 64 }).notNull(),
    promptCacheHit: boolean('prompt_cache_hit'),
    inputTokens: integer('input_tokens'),
    outputTokens: integer('output_tokens'),
    cachedTokens: integer('cached_tokens'),
    costUsd: integer('cost_micro_usd'),
    durationMs: integer('duration_ms'),
    errorMessage: text('error_message'),
    // ADDITIVE (model-throttle, 2026-07-21): when the throttle steps a default-tier
    // call DOWN the ladder, this records the model it WOULD have used (the requested
    // latest/Opus). NULL on a normal call. Makes a downgrade legible instead of
    // hidden — CLAUDE.md rule 10 (never silence the cost meter) applied to the
    // throttle: model_id is what actually ran, degraded_from is what was asked for.
    degradedFrom: varchar('degraded_from', { length: 64 }),
    ...timestamps,
  },
  (t) => ({
    // ADDITIVE (model-throttle, 2026-07-21): the throttle's per-user rolling-spend
    // meter is SUM(cost_micro_usd) WHERE user_id = ? AND created_at >= now()-window.
    // This composite index makes that a range scan instead of a full table scan as
    // ai_call_log grows. Additive only; mirrors the DDL in the design doc.
    userCreatedIdx: index('ai_call_log_user_created_idx').on(t.userId, t.createdAt),
  }),
);

export const cronRuns = pgTable('cron_runs', {
  id: id(),
  jobName: varchar('job_name', { length: 64 }).notNull(),
  startedAt: timestamp('started_at', { withTimezone: true }).notNull(),
  finishedAt: timestamp('finished_at', { withTimezone: true }),
  status: varchar('status', { length: 16 }).notNull(),
  metricsJson: jsonb('metrics_json'),
  errors: jsonb('errors'),
  ...timestamps,
});
